export const AdminLandingPage = () => {
    return (
        <div className="hero-banner">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12 col-md-6">
                        <div className="hero-banner__inner">
                            <h1 className="hero-banner__title">Welcome, Admin</h1>
                            <div className="hero-banner-meta">
                                <p className="loggedin">
                                    Admin is the role with the highest level of access to GP Diary. Admins can add content on all pages and access all items in the Admin Page.
                                </p>
                                <p className="loggedin">
                                    Admins can control site-wide settings like add, edit and delete the countries, JobCategory, JobSubCategories, work hours and contents.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12 col-md-6">
                        <figure className="hero-banner__rotachecker">
                            <img src={require('../../../assets/images/admin-landing-page.png')} alt="admin-landing-page" />
                        </figure>
                    </div>
                </div>
            </div>
        </div>
    )
}